import {
  getLastTwoMonths,
  getTrailing15DaysFromToday,
  getTrailing8WeeksFromToday,
} from '@amzn/aet-galactus-kit/lib/timestampUtils';
import DateCompare from '../Types/DateCompare';
import moment from 'moment';

export { default as convertEnumToObject } from './Helper';
export * from './Week';
export * from './Metric';
export * from './Colors';
export * from './State';
export * from '../config/Url';
export * from './Logger';

export enum Page {
  DASHBOARD = 'DASHBOARD',
  COACHING = 'COACHING',
  HMD_DETAILS = 'HMD_DETAILS',
  CCX_DETAILS = 'CCX_DETAILS',
  METRICS = 'METRICS',
  TEAM = 'TEAM',
}

export const COACHING_TEXT_LIMIT = 2000;

function formatDate(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function getDateRange(
  dateSelection: string,
  customStartDate?: string,
  customEndDate?: string
): {
  startDate: string;
  endDate: string;
} {
  let endDate = '';
  let startDate = '';
  switch (dateSelection) {
    case DateCompare.DAY:
      startDate = getTrailing15DaysFromToday()[0];
      endDate =
        getTrailing15DaysFromToday()[getTrailing15DaysFromToday().length - 1];
      break;
    case DateCompare.WEEK:
      let first = getTrailing8WeeksFromToday()[0];
      let last =
        getTrailing8WeeksFromToday()[getTrailing8WeeksFromToday().length - 1];
      // GGGG refers to the year of the week. This may be different from YYYY
      // When part of the week is from 2024 and part of it is from 2025. e.g. 2024-12-30 (Monday)
      // In such cases, GGGG refers to the new year (e..g 2025) and YYYY refers to the previous year (e.g. 2024).
      const firstWeekYear = moment(first, 'GGGG-WW');
      startDate = firstWeekYear
        .startOf('isoWeek')
        .subtract(1, 'days')
        .format('YYYY-MM-DD');
      const lasttWeekYear = moment(last, 'GGGG-WW');
      endDate = lasttWeekYear
        .endOf('isoWeek')
        .subtract(1, 'days')
        .format('YYYY-MM-DD');
      break;
    case DateCompare.MONTH:
      startDate = getLastTwoMonths()[1][0];
      endDate = getLastTwoMonths()[0][1];
      break;
    case DateCompare.CUSTOM:
      startDate = moment(customStartDate).format('YYYY-MM-DD');
      endDate = moment(customEndDate).format('YYYY-MM-DD');
      break;
    default:
      console.error('dateSelection value:', dateSelection);
      throw new Error('Invalid date selection');
  }
  return {
    startDate: startDate,
    endDate: endDate,
  };
}

export function titleCase(text: string) {
  return text && text.length > 1
    ? text.charAt(0).toUpperCase() + text.substr(1).toLowerCase()
    : text;
}

export function isDateValid(date: string) {
  const dateAsMoment = moment(date, 'YYYY-MM-DD', true);
  if (!dateAsMoment.isValid()) {
    return false;
  }
  const today = moment();
  const oneYearAgo = moment().subtract(1, 'years');
  return dateAsMoment < oneYearAgo || dateAsMoment > today;
}
